/* eslint-disable camelcase */
/**
 * @author Daniel Aguirre
 * @file index.jsx
 * @description NephroPlusChats Edit/View Page.
 */

// Dependencies
import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';

import AppCardLayout from 'components/AppCardLayout';

const parameterKey = 'CHATBOT_IFRAME';

const NephroPlusChatView = ({ parameterActions }) => {
  const { getParameterByKey } = parameterActions;
  const [parameter, setParameter] = useState(null);

  const onGetParameter = (_, response) => {
    const parameterResposne = response?.data?.param_value;
    if (parameterResposne) {
      setParameter(parameterResposne);
    }
  };

  useEffect(() => {
    getParameterByKey({ parameterKey }, onGetParameter);
  }, []);

  return (
    <AppCardLayout>
      <div className="p-4 h-full">
        {parameter && (
          <iframe
            src={parameter}
            style={{
              minWidth: 250,
              width: '100%',
              height: '100%',
              margin: 'auto'
            }}
          />
        )}
      </div>
    </AppCardLayout>
  );
};

/**
 * @name PageHeader.propTypes
 * @type { Object }
 */
NephroPlusChatView.propTypes = {
  parameterActions: PropTypes.shape({
    getParameterByKey: PropTypes.func.isRequired
  }).isRequired
};

export default NephroPlusChatView;
